import { InjectionKey } from "vue";
import { SSOConfig } from "@telegraphio/bapi-types";

export const SSO_CONFIG_KEY: InjectionKey<SSOConfig> = Symbol("SSO_CONFIG");
